/**
 * 文件上传通用 Mixin
 * 提供普通上传（非OSS）的通用方法和状态管理
 * 参考: ConcreteCloud_Web/src/components/businessInstance/procedureAnnex/index.vue
 *
 * 使用方式:
 *   import { mixin_fileUpload } from '@/assets/mixin/mixin_fileUpload';
 *   export default {
 *       mixins: [mixin_fileUpload],
 *       methods: {
 *           handleUpload(param) {
 *               this.uploadFileMethod(param, {
 *                   businessTypeCode: 'Flow',
 *                   dataId: this.formId,
 *                   directoryId: this.currentFolderId,
 *                   platformEnterprises: this.platformEnterprises,
 *               }).then(res => {
 *                   // 上传成功回调
 *                   console.log('上传成功', res);
 *               }).catch(err => {
 *                   // 上传失败回调
 *               });
 *           },
 *       },
 *   };
 */

export const mixin_fileUpload = {
    data() {
        return {
            // 文件上传进度条状态
            isProgress: false,
            // 文件上传进度
            progressPercent: 0,
        };
    },
    methods: {
        // 文件大小转换
        bytesToSize(fileByte) {
            const fileSizeByte = fileByte;
            let fileSizeMsg = '';
            if (fileSizeByte < 1048576) {
                fileSizeMsg = (fileSizeByte / 1024).toFixed(1) + 'KB';
            } else if (fileSizeByte === 1048576) {
                fileSizeMsg = '1MB';
            } else if (fileSizeByte > 1048576 && fileSizeByte < 1073741824) {
                fileSizeMsg = (fileSizeByte / (1024 * 1024)).toFixed(1) + 'MB';
            } else if (fileSizeByte > 1048576 && fileSizeByte === 1073741824) {
                fileSizeMsg = '1GB';
            } else if (fileSizeByte > 1073741824 && fileSizeByte < 1099511627776) {
                fileSizeMsg = (fileSizeByte / (1024 * 1024 * 1024)).toFixed(1) + 'GB';
            } else {
                fileSizeMsg = '文件超过1TB';
            }
            return fileSizeMsg;
        },

        /**
         * 普通文件上传方法（非OSS）
         * @param {Object} param - el-upload 的 http-request 参数，包含 file 等
         * @param {Object} options - 上传配置选项
         * @param {number} options.fileType - 文件类型，默认 0（文件），1为文件夹
         * @param {string} options.businessTypeCode - 业务类型编码，默认 'Flow'
         * @param {string} options.dataId - 业务数据ID
         * @param {string} options.directoryId - 目录ID，默认空字符串
         * @param {string} options.platformEnterprises - 企业平台标识
         * @param {Function} options.onProgress - 上传进度回调
         * @returns {Promise} - 上传结果 Promise
         */
        uploadFileMethod(param, options = {}) {
            const tenantId = this.$takeTokenParameters('TenantId');
            const {
                fileType = 0,
                businessTypeCode = 'Flow',
                dataId = '',
                directoryId = '',
                platformEnterprises = '',
                onProgress = null,
            } = options;

            const formData = new FormData();
            formData.append('FileType', fileType);
            formData.append('BusinessTypeCode', businessTypeCode);
            formData.append('DataId', dataId);
            formData.append('DirectoryId', directoryId);
            formData.append('TenantId', tenantId);
            formData.append('File', param.file);

            const config = {
                onUploadProgress: progressEvent => {
                    this.progressPercent = 0;
                    this.isProgress = true;
                    this.progressPercent = Number((progressEvent.loaded / progressEvent.total * 100).toFixed(2));
                    if (onProgress) {
                        onProgress(this.progressPercent, progressEvent);
                    }
                },
            };

            const url = `${this.FILE.FILE_BASE_URL()}file-manage?__tenant=${tenantId}&platformEnterprises=${platformEnterprises}`;
            return this.$axios.post(url, formData, config);
        },
    },
};
